import {useCallback, useMemo, useState} from 'react';
import {invokeAsync} from '..';
import {WellEntity} from '@features/wells/types';
import {WellsService} from '@services/Wells/WellsService';

export type WellsDataStore = {
    data: WellEntity[];
};

export const useWellsData = () => {
    const [store, setStore] = useState<WellsDataStore>();

    const update = useCallback(() => {
        void invokeAsync(async () => {
            const service = WellsService.getInstance();
            const data = await service.getWells({});

            setStore({
                data,
            });
        });
    }, []);

    return useMemo(() => [store, update] as const, [store, update]);
};
